module.exports = __webpack_public_path__ + "static/Solution_ImgEMI-71fceeded572a0c85085279c8aef2eb7.png";